export default __webpack_public_path__ + "static/media/resultmissing.0ddfdee0.png";